import {
  Briefcase,
  CaretDown,
  Gear,
  Gift,
  Lightbulb,
  Question,
  SignOut,
} from "@phosphor-icons/react";
import { clsx } from "clsx";
import { useState } from "react";
import { Link } from "react-router-dom";

import RelativeLink from "common/components/RelativeLink";
import RenderIf from "common/components/RenderIf";
import AimfoxAvatar from "common/components/ui/AimfoxAvatar";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useCustomer from "common/datahooks/useCustomer";
import { getUserback } from "common/helpers/userbackClient";
import { getWhitelabelCustomization } from "common/helpers/utils";
import ExtraNavItems from "common/layouts/WorkspaceLayout/ExtraNavItems";
import LogOutModal from "common/layouts/WorkspaceLayout/LogOutModal";
import NavItem from "common/layouts/WorkspaceLayout/NavItem";

export default function MobileProfilePopup() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);

  const { customerInfo } = useCustomer();
  const { first_name: firstName, last_name: lastName, email } = customerInfo;
  const { role } = useSelectedWorkspaceContext();

  return (
    <>
      <div
        className={clsx(
          " p-4 rounded-7xl mt-auto flex absolute bottom-2 inset-x-2 flex-col transition-[shadow,background] overflow-hidden duration-500",
          isExpanded
            ? "shadow-[0_0_25px_0_rgba(17,24,39,0.10)] bg-white"
            : "bg-white/50",
        )}
      >
        <button
          className="flex items-center gap-x-3"
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <AimfoxAvatar firstName={firstName} lastName={lastName} size="lg" />
          <div className="flex flex-col gap-y-0.5 flex-1">
            <span className="text-lg-bold text-left">
              {firstName} {lastName}
            </span>
            <span className="text-black-500 text-sm-medium text-left">
              {email}
            </span>
          </div>
          <CaretDown
            className={clsx(
              "size-5 m-2.5 text-black-500 transition-transform",
              isExpanded && "rotate-180",
            )}
          />
        </button>
        <div
          className={clsx(
            "grid transition-[grid,padding] overflow-hidden ease-in-out duration-300",
            isExpanded ? "grid-rows-[1fr] pt-2" : "grid-rows-[0fr] pt-0",
          )}
        >
          <div className="flex flex-col h-full overflow-hidden">
            <RelativeLink to="settings">
              <NavItem isExpanded icon={<Gear weight="fill" />}>
                Settings
              </NavItem>
            </RelativeLink>
            <RenderIf condition={!getWhitelabelCustomization()}>
              <RenderIf condition={role === "owner"}>
                <RelativeLink to="settings/agency">
                  <NavItem isExpanded icon={<Briefcase weight="fill" />}>
                    Agency plan
                  </NavItem>
                </RelativeLink>
              </RenderIf>

              {window.Cello && (
                <button
                  type="button"
                  data-target="cello-button"
                  onClick={() => window.Cello("open")}
                >
                  <NavItem isExpanded icon={<Gift weight="fill" />}>
                    Referral program
                  </NavItem>
                </button>
              )}

              <button type="button" onClick={() => getUserback().openForm()}>
                <NavItem isExpanded icon={<Lightbulb weight="fill" />}>
                  Feedback & Roadmap
                </NavItem>
              </button>
              <Link
                to="https://help.aimfox.com/en/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <NavItem isExpanded icon={<Question weight="fill" />}>
                  Knowledge base
                </NavItem>
              </Link>
              <ExtraNavItems isExpanded />
            </RenderIf>
            <button type="button" onClick={() => setIsLogOutModalOpen(true)}>
              <NavItem isExpanded icon={<SignOut />}>
                Log out
              </NavItem>
            </button>
          </div>
        </div>
      </div>
      <LogOutModal
        isOpen={isLogOutModalOpen}
        setIsOpen={setIsLogOutModalOpen}
      />
    </>
  );
}
